import React from "react";
import SVG from "react-inlinesvg";
import { config } from "config/env";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
  ClockIllustration,
  ExpiredContainer,
  ExpiredContent,
  ExpiredDescription,
  ExpiredPage,
  ExpiredText,
  ExpiredTitle,
  GlobalStyles,
} from "../styles";

export const PaymentLinkExpired = () => {
  const handleContactSupport = () => {
    window.open(config.support.whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <GlobalStyles />
      <ExpiredPage>
        <ExpiredContainer>
          <ExpiredContent>
            <ClockIllustration>
              <SVG
                src={toAbsoluteUrl("/media/clock-banner.svg")}
                alt="Relógio indicando tempo expirado"
              />
            </ClockIllustration>
            <ExpiredText>
              <ExpiredTitle>Link de pagamento expirado</ExpiredTitle>
              <ExpiredDescription>
                O link de pagamento que você tentou acessar não está mais
                disponível. Para continuar, entre em contato com o time de
                suporte, eles irão te ajudar a gerar um novo link e concluir o
                pagamento rapidamente.
              </ExpiredDescription>
            </ExpiredText>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleContactSupport}
            >
              Falar com suporte
            </button>
          </ExpiredContent>
        </ExpiredContainer>
      </ExpiredPage>
    </>
  );
};
